// removed by extract-text-webpack-plugin
module.exports = {"ScreenXXSMax":"(max-width: 543px)","row":"G423f65","dropDownContainer":"G4cb1a0","editDeliveryOuterContainer":"G71651d"};